import { Mapper } from "../../../../base/utils/mapper";
import { TypeProcedureModel } from "../../../../domain/models/consult/type-procedure.model";
import { TypeProcedureEntity } from "../entities/type-procedure.entity";


export class TypeProcedureImplementationRepositoryMapper extends Mapper<TypeProcedureEntity, TypeProcedureModel> {
    mapFrom(param: TypeProcedureEntity): TypeProcedureModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeProcedureModel): TypeProcedureEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}